import styles from './css/AllInvoices.scss';
import Card from '@mui/material/Card';
import CardHeaderCD from '../../component/CardHeaderCD';
import { CardContent } from '@mui/material';

/* const ClientList = R.compose(
	getHistoryListDefaultHOCEnhance({
		store,
		method: 'GET',
		url: '/get/all/clients',
		options: { reactQuery: { queryName: 'getAllClients' } }
	}),
	withProps({
		onIcon: () => <ClientIcon />
	})
)(HistoryList); */

const CreateCharge = props => {
	return (
		<div className={styles.wrap}>
			<Card>
				<CardHeaderCD title="CREATE CHARGE" />
				<CardContent>NEW CHARGE</CardContent>
			</Card>
		</div>
	);
};
export default CreateCharge;
